<form class="flex flex-col gap-4" [formGroup]="productForm" (ngSubmit)="onSubmit()">
  <!-- Location -->
  <div class="flex flex-col">
    @if (!locationOptions().length) {
      <label>Location</label>
      <p class="text-surface-400 text-body-xs m-0">No locations available for this option.</p>
    } @else {
      <p-floatlabel variant="on">
        <generic-dropdown
          class="w-full"
          placeholder=""
          [items]="locationOptions()"
          [clearable]="!isLocked() || canMoveLockedOption()"
          [disabled]="isLocked() && !canMoveLockedOption()"
          formControlName="locationId"
        />
        <label>Location</label>
      </p-floatlabel>
    }
  </div>

  <!-- Quantity -->
  <div class="flex flex-col">
    <p-floatlabel variant="on">
      <p-inputnumber
        class="w-full"
        styleClass="w-full"
        formControlName="quantity"
        [min]="1"
        [showButtons]="false"
        [disabled]="isLocked()"
        (onBlur)="onSubmit()"
      />
      <label>Quantity</label>
    </p-floatlabel>
    @if (productForm.controls.quantity.touched && productForm.controls.quantity.invalid) {
      <p class="text-red-500 text-body-xs m-0">Quantity is required.</p>
    }
    @if (noMeasurementDefined()) {
      <p-message class="mt-1.5" severity="error" size="small"
        >No measurement is defined for this room. Please enter the quantity and unit price manually.</p-message
      >
    }
  </div>

  <!-- Unit Price with UoM suffix -->
  <div class="flex flex-col">
    <div class="flex items-center gap-2">
      <div class="flex-1">
        <!-- focusout (bubbling blur) since the input lives inside the currency component -->
        <p-floatlabel variant="on">
          <currency-input-field
            formControlName="unitPrice"
            [min]="null"
            [customClass]="'form-control'"
            (focusout)="onSubmit()"
          ></currency-input-field>
          <label class="z-10">Unit Price</label>
        </p-floatlabel>
      </div>
      @if (addendumOption().uofm?.code || addendumOption().uofm?.name) {
        <span class="text-body-sm text-surface-500 shrink-0 whitespace-nowrap">
          /{{ addendumOption().uofm?.code ?? addendumOption().uofm?.name }}
        </span>
      }
    </div>
  </div>

  <!-- Attributes -->

  @if (productAttributes().length) {
    <div [formGroup]="attributeValuesControl" class="flex flex-col gap-4">
      @for (attribute of productAttributes(); track attribute.subCategoryAttributeId) {
        <div class="flex flex-col">
          <p-floatlabel variant="on">
            <p-select
              [formControlName]="attribute.subCategoryAttributeId"
              [options]="getAttributeSelectOptions(attribute.subCategoryAttributeId)"
              optionLabel="value"
              optionValue="id"
              optionDisabled="disabled"
              [filter]="true"
              [showClear]="true"
              appendTo="body"
              styleClass="w-full"
              [disabled]="isLocked()"
              (onChange)="onSubmit()"
            >
              <ng-template let-item pTemplate="item">
                <div
                  class="flex items-center gap-2 py-0.5"
                  [class.opacity-60]="!item.isActive"
                  [class.line-through]="!item.isActive"
                >
                  <span>{{ item.value }}</span>
                  @if (!item.isActive) {
                    <span class="text-body-2xs rounded bg-surface-100 px-1.5 py-0.5 text-surface-500">Inactive</span>
                  }
                </div>
              </ng-template>
            </p-select>
            <label>{{ attribute.subCategoryAttributeName }}</label>
          </p-floatlabel>
          @if (!attributeValuesMap().get(attribute.subCategoryAttributeId)?.length) {
            <p class="text-surface-400 text-body-xs m-0">No values available for this attribute.</p>
          }
        </div>
      }
    </div>
  } @else {
    <div class="flex flex-col">
      <label>Attributes</label>
      <p class="text-surface-400 text-body-xs m-0">No attributes available for this option.</p>
    </div>
  }

  <!-- Sales Description -->
  <div class="flex flex-col gap-1">
    <label class="mb-0">Sales Description</label>
    <p class="text-body-xs text-surface-700 m-0">{{ addendumOption().salesDescription ?? '—' }}</p>
  </div>

  <!-- Option Notes -->
  <div class="flex flex-col">
    <p-floatlabel variant="on">
      <textarea
        pTextarea
        id="optionNotes"
        rows="4"
        class="w-full"
        [disabled]="isLocked()"
        formControlName="notes"
        (blur)="onSubmit()"
      ></textarea>
      <label for="optionNotes">Option Notes</label>
    </p-floatlabel>
  </div>

  <!--
  <p-button label="Save" type="submit" [disabled]="isLocked()" styleClass="w-full justify-center" />
  -->
</form>

<p-confirmdialog appendTo="body" />
